import { Card, Typography, Button, Checkbox } from '@material-tailwind/react'
import { fmt, norm } from './utils'

export function GroupCard({ group, selected, toggleGroup, onApprove, onReject, onApproveOne, onRejectOne }) {
  const allSelected = selected[group.group_id] === true
  const expired = group.expired === true

  return (
    <Card className={`w-full p-4 border ${expired ? 'border-gray-200 bg-gray-50 opacity-75' : 'border-gray-200 bg-white'}`}>
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 sm:gap-3">
        <div className="flex items-start sm:items-center gap-3">
          <Checkbox checked={allSelected} onChange={() => toggleGroup(group.group_id)} disabled={expired || group.count === 0} />
          <div className="min-w-0">
            <Typography className="font-semibold truncate">
              {group.office_name}
              <span className="text-gray-500 font-normal"> · {group.count} invitaci{group.count === 1 ? 'ón' : 'ones'}</span>
            </Typography>
            <Typography variant="small" className="text-gray-600">
              Creadas: {fmt(group.created_at)}
              <br />
              Ventana: {group.window_text}
            </Typography>
          </div>
        </div>

        {!expired && (
          <div className="flex flex-wrap items-center gap-2 mt-1 sm:mt-0">
            <Button size="sm" onClick={() => onApprove(group.group_id)} disabled={group.count === 0}>Aprobar</Button>
            <Button size="sm" variant="outlined" color="red" onClick={() => onReject(group.group_id)} disabled={group.count === 0}>Rechazar</Button>
          </div>
        )}
      </div>

      <div className="mt-3">
        <ul className="divide-y divide-gray-200">
          {group.items.map((inv) => {
            const vd = inv?.visitor_data || {}
            const showTokenAlias = vd.token_name && norm(vd.token_name) !== norm(vd.name)
            const company = vd.origin_company || vd.company_name || null
            const invitedBy = inv?.created_by_name || null

            return (
              <li key={inv.id} className="py-3 flex flex-col gap-1 w-full">
                <div className="min-w-0 flex-1">
                  <p className="font-medium text-gray-900 truncate">
                    {vd.name || '—'}
                    {vd.document_number && <span className="ml-2 text-xs text-gray-500">({vd.document_number})</span>}
                  </p>
                  {showTokenAlias && <p className="text-xs italic text-gray-500 truncate">{vd.token_name}</p>}
                  {company && <p className="text-xs text-gray-700 truncate">{company}</p>}
                  <p className="text-sm text-gray-600 truncate">{vd.email || '—'}</p>
                  {vd.host_person && <p className="text-xs text-gray-500 mt-0.5 truncate">Visita a: {vd.host_person}</p>}
                  {invitedBy && <p className="text-[11px] text-gray-500 mt-0.5 truncate">Invitado por: {invitedBy}</p>}
                </div>

                {!expired && (
                  <div className="flex items-center gap-3 pt-1">
                    <Button size="sm" variant="text" onClick={() => onApproveOne(inv.id)}>Aprobar</Button>
                    <Button size="sm" variant="text" color="red" onClick={() => onRejectOne(inv.id)}>Rechazar</Button>
                  </div>
                )}
              </li>
            )
          })}
        </ul>
      </div>
    </Card>
  )
}